import styles from './RecipeList.module.css'
import {useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const RecipeList = ({recipes, name = "", setPage}) => {
  console.log(recipes)
  return (
    <>
      <div
        id={name}
        data-testid={name}
        className={styles.recipeList}
      >
        {
          recipes.content.map((recipe) => (
            <RecipeListItem key={recipe.name} recipe={recipe}/>
          ))
        }
      </div>
      <div className={styles.pages}>
        <button disabled={recipes.number === 0} onClick={() => setPage(recipes.number - 1)}>
          <FontAwesomeIcon icon={["far", "arrow-left"]}/>
        </button>
        {
          Array.from({length: recipes.totalPages}, (_, i) => i + 1).map(i => (
            <button key={i.toString()} onClick={() => {
              setPage(i - 1)
              window.scrollTo(0,0);
            }} className={recipes.number === (i - 1) ? styles.selected : ""}>{i}</button>
          ))
        }
        <button disabled={recipes.number === (recipes.totalPages - 1)} onClick={() => setPage(recipes.number + 1)}>
          <FontAwesomeIcon icon={["far", "arrow-right"]}/>
        </button>
      </div>
    </>
  )
}

const RecipeListItem = ({recipe}) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleRecipe = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className={styles.recipeListItemWrapper}>
      <div className={styles.recipeListItem} onClick={toggleRecipe}>
        <h1>{recipe.name}</h1>
      </div>
      <div className={`${styles.recipeListItemDetails} ${isOpen ? styles.displayed : ""}`}>
        {recipe.instructions}
        <br/><br/>
        {
          recipe.ingredients.map((ing) => (
            <li key={ing}>{ing}</li>
          ))
        }
      </div>
    </div>
  )
}

export default RecipeList
